<div class="lg:px-10 py-8">
  <img
    class="max-w-screen-sm mx-auto lg:w-full h-full object-cover"
    *ngIf="logo"
    [src]="logo.url"
    alt="Hero image"
  />
</div>
